import type { BaseEnvelope } from './base-patch';
import type { FromBaseEntryResult } from './from-base-entry';
import type { CachePutBody, CachePutSkip } from '../../websocket/cache-put-body';
import type { WorkerTreePatch } from './worker-tree-patch';

export interface CacheBodyReply { kind: 'cache-body'; sequence: number; engine: string; request: CachePutBody | null; skip?: CachePutSkip }
export interface CompileSnapshot { worker_snapshot: number }
export interface CompileProgress { kind: 'compile-progress'; sequence: number; progress: number; stage: string }

export interface CompileRequest {
    sequence: number; engine: string; envelope: BaseEnvelope | string; raw_ref?: number;
    auraOwners?: Record<string, Record<string, unknown>>;
    result_ref?: number;
    input_patch?: { previous: number; changes: WorkerTreePatch };
}
export interface CompileReply {
    sequence: number; engine: string; entity: string; entity_id: string; base_rev: number;
    result?: FromBaseEntryResult; error?: string; snapshot?: CompileSnapshot;
    members: { compiles: number; hits: number };
    memberCompiles?: Record<string, number>;
    needsBase?: boolean;
    result_patch?: { previous: number; changes: WorkerTreePatch };
}
export const compileRevisionKey = (envelope: BaseEnvelope): string =>
    JSON.stringify([envelope.entity, envelope.entity_id.toUpperCase(), envelope.base_rev, envelope.engine, envelope.catalog_version ?? null]);

/** Saved response wrappers already accepted by compileFetchedEntity. */
export function responseBase(value: unknown): BaseEnvelope | undefined {
    if (!value || typeof value !== 'object') return;
    const row = value as Record<string, unknown>;
    if (typeof row.entity === 'string' && typeof row.entity_id === 'string' && typeof row.base_rev === 'number' && row.base)
        return value as BaseEnvelope;
    for (const name of ['_entity_base', '_inventory_base', 'caster_arr', 'encounter_arr']) {
        const child = row[name];
        if (child && typeof child === 'object') { const base = responseBase(child); if (base) return base; }
    }
}
